import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThreemaComponent } from './simple-icons-threema.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThreemaComponent ],
    exports:      [ SimpleIconsThreemaComponent ],
    bootstrap:    []
})
export class SimpleIconsThreemaModule {}
